import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-body text-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Payment Successful", -1)
const _hoisted_5 = {
  key: 0,
  class: "pdt-10"
}
const _hoisted_6 = {
  key: 1,
  class: "pdt-10"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Payment Failed", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "pdt-10" }, "Payment has not been made", -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Payment Successful", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "pdt-10" }, "Payment has been made", -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", null, "Payment Failed", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "pdt-10" }, "Payment has not been made", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.type == 'capp')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                (_ctx.transactionId)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Coverage Selection has been made, transaction id: # " + _toDisplayString(_ctx.transactionId), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_6, "Coverage Selection has been made.")),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToDashboard && _ctx.goToDashboard(...args)), ["prevent"])),
                  class: "btn btn-primary mt-20"
                }, "Go Back")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"])),
                  class: "btn btn-primary mt-20"
                }, "Go back")
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToDashboard && _ctx.goToDashboard(...args)), ["prevent"])),
                  class: "btn btn-primary mt-20"
                }, "Go to dashboard")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16,
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('hw-cobra-statements', 'Make COBRA Payment', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"])),
                  class: "btn btn-primary mt-20"
                }, "Go back to Invoices")
              ]))
        ]))
  ]))
}